import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import {
  dialogSize // userRightTypes
} from '../../../../constants'
import { updateScenario } from '../../../../actions'
import { checkErrorResponse, Logger, LoggerTypes } from '../../../../utils'
import {
  // AccessControl, AccessControlNoRights,
  DialogFormEdit
} from '../../../../components'
import { ScenarioForm } from '../ScenarioForm'

export const ScenarioDialogUpdate = forwardRef(({ scenario, openDialog, setOpenDialog }, ref) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const params = useParams()

  // -- get projectID from URL.
  const { pid } = params

  const onClickCancel = (e) => {
    e.preventDefault()

    Logger.trace(LoggerTypes.CONTROLLER, 'ScenarioDialogUpdate.onClickCancel()', { e })

    setOpenDialog(!openDialog)
  }

  const onDispatchAction = (scenarioUpdated, _onSuccess, _onFail) => {
    Logger.trace(LoggerTypes.CONTROLLER, 'ScenarioDialogUpdate.onDispatchAction()', { scenarioUpdated })

    dispatch(updateScenario(pid, scenarioUpdated))
      .then((res) => {
        Logger.trace(LoggerTypes.CONTROLLER, 'ScenarioDialogUpdate.dispatch(updateScenario(...)).then()', {
          res
        })

        const newScenario = res?.data || {}

        if (newScenario.id) {
          if (_onSuccess && typeof _onSuccess === 'function') {
            _onSuccess(newScenario)
          }
          setOpenDialog(!openDialog)
        } else {
          enqueueSnackbar(t('common.api_failure'), newScenario)

          if (_onFail && typeof _onFail === 'function' && res?.response?.data?.fields) {
            _onFail(res?.response?.data?.fields)
          }
        }
      })
      .catch((res) => {
        Logger.trace(LoggerTypes.WARN, 'ScenarioDialogUpdate.dispatch(updateScenario(...)).catch()', {
          res
        })

        checkErrorResponse(res, enqueueSnackbar, t)

        if (_onFail && typeof _onFail === 'function' && res?.response?.data?.fields) {
          _onFail(res.response.data.fields)
        }
      })
  }

  // const onSubmit = (e, scenarioUpdated) => {
  //   e.preventDefault()
  //   e.stopPropagation()
  //
  //   Logger.trace(LoggerTypes.CONTROLLER, 'ScenarioDialogUpdate.onSubmit()', { scenarioUpdated }
  //
  //   dispatch(updateScenario(pid, scenarioUpdated))
  //     .then((res) => {
  //       Logger.trace(LoggerTypes.CONTROLLER, 'ScenarioDialogUpdate.onSubmit().updateScenario().then()', { res })
  //       setOpenDialog(!openDialog)
  //     })
  //     .catch((res) => {
  //       Logger.trace(LoggerTypes.WARN, 'ScenarioDialogUpdate.onSubmit().updateScenario().catch()', { res })
  //       checkErrorResponse(res, enqueueSnackbar, t)
  //       if (res?.response?.data?.fields) {
  //         setErrors(res.response.data.fields)
  //       }
  //     })
  // }

  Logger.trace(LoggerTypes.CONTAINER, 'ScenarioDialogUpdate.render()', { ref, openDialog, scenario })

  return (
    <DialogFormEdit openDialog={openDialog} setOpenDialog={setOpenDialog} maxWidth={dialogSize.EXTRA_SMALL}>
      <ScenarioForm
        title={t('scenarios.dialogs.update.title')}
        onCancel={onClickCancel}
        // onSubmit={onSubmit}
        scenario={scenario}
        dispatchAction={onDispatchAction}
      />
    </DialogFormEdit>
  )
})

ScenarioDialogUpdate.displayName = 'ScenarioDialogUpdate'

ScenarioDialogUpdate.propTypes = {
  scenario: PropTypes.object.isRequired,
  openDialog: PropTypes.bool.isRequired,
  setOpenDialog: PropTypes.func.isRequired
}

ScenarioDialogUpdate.defaultProps = {
  scenario: {},
  openDialog: false,
  setOpenDialog: () => {}
}
